export enum INDEX_PAGE_WITH_FILTERS {
  CONTROLS = 'controls',
  ACTIVITIES = 'activities',
  CONTROLS_BY_REQUIREMENT = 'controls_by_requirement',
  POLICIES = 'policies',
  DOCUMENT_SCAN = 'document_scan',
  RISKS = 'risks',
  REQUESTS = 'requests',
  SERVICES = 'services',
  RECEPTORS = 'receptors',
  FRAMEWORKS = 'frameworks',
  FRAMEWORK_REQUIREMENTS = 'framework_requirements',
  VENDORS = 'vendors',
  EVIDENCE = 'evidence',
  SECURITY_QUESTIONNAIRE = 'security_questionnaire',
  VENDOR_QUESTIONNAIRES = 'vendor_questionnaires',
  RECEIVED_QUESTIONNAIRES = 'received_questionnaires',
  AUDIT_BOT = 'audit_bot',
  REPORT_SCAN = 'report_scan',
  USERS = 'users',
  AUDIT = 'audit',
  OE_DASHBOARD_OVERVIEW = 'operating_effectiveness_overview_dashboard',
  OE_DASHBOARD_DETAIL = 'operating_effectiveness_detail_dashboard',
  REPORTS = 'reports',
  RISK_RESPONSE_DASHBOARD = 'risk_response_dashboard',
  TP_ACCESS_REQUESTS_DASHBOARD = 'tp_access_requests_dashboard',
  TP_GRANTED_REQUESTS_DASHBOARD = 'tp_granted_requests_dashboard',
  TP_DOCUMENT_DOWNLOADS_DASHBOARD = 'tp_document_downloads_dashboard',
  TP_FAQ_CLICKS_DASHBOARD = 'tp_faq_clicks_dashboard',
  TP_SEARCHES_DASHBOARD = 'tp_searches_dashboard',
  TP_TI_CHATS_DASHBOARD = 'tp_ti_chats_dashboard',
  TP_TI_QUESTIONS_DASHBOARD = 'tp_ti_questions_dashboard',
  TP_UPDATE_NOTIFICATION_SUBSCRIPTIONS_DASHBOARD = 'tp_update_notification_subscriptions_dashboard',
  TP_UPDATE_NOTIFICATION_UNSUBSCRIPTIONS_DASHBOARD = 'tp_update_notification_unsubscriptions_dashboard',
  SCHEDULING = 'scheduling',
  PLAYBOOKS = 'playbooks',
  OVERVIEW_DASHBOARD = 'overview_dashboard',
  VENDOR_HEALTH_DASHBOARD = 'vendor_health_dashboard',
  INTERNAL_ACCOUNT_MANAGEMENT = 'internal_admin_panel',
}

const DEFAULT_INDEX_PAGE_FILTERS = {
  RECEPTORS: '?status[]=Active',
}

export const DEFAULT_INDEX_STATE_PARAMS = {
  RECEPTORS: DEFAULT_INDEX_PAGE_FILTERS.RECEPTORS,
}
